const guiColors = {
    'motion-primary': '#ffcc00', // bright yellow
    'motion-primary-transparent': '#ffcc00e6', // semi-transparent yellow
    'motion-tertiary': '#e6b800', // darker yellow

    'looks-secondary': '#ffcc00', // bright yellow
    'looks-transparent': '#ffcc0059', // more transparent yellow
    'looks-light-transparent': '#ffcc0026', // very transparent yellow
    'looks-secondary-dark': 'hsla(48, 100%, 40%, 1)', // dark yellow

    'extensions-primary': 'hsla(50, 100%, 65%, 1)', // light yellow
    'extensions-tertiary': 'hsla(50, 90%, 45%, 1)', // medium yellow
    'extensions-transparent': 'hsla(50, 90%, 65%, 0.35)', // semi-transparent yellow
    'extensions-light': 'hsla(50, 100%, 85%, 1)', // very light yellow

    'drop-highlight': '#ffdb4d' // light yellow
};

const blockColors = {
    checkboxActiveBackground: '#ffcc00', // bright yellow
    checkboxActiveBorder: '#e6b800' // darker yellow
};

export {
    guiColors,
    blockColors
};
